import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ec6c913"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "main",
  style: {"margin":"10px"}
}
const _hoisted_2 = {
  class: "container",
  style: {"height":"55px","padding-bottom":"50px"}
}
const _hoisted_3 = { class: "image2" }
const _hoisted_4 = { class: "col-button" }
const _hoisted_5 = {
  href: "/",
  target: "_blank"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Top up or buy a new esim"),
  /*#__PURE__*/_createElementVNode("div", { class: "links-container" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://sg.shp.ee/Wn1Z7zM",
      class: "qr-link",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("span", null, "Click to go to our Shopee store"),
      /*#__PURE__*/_createElementVNode("img", {
        src: "/images/redeem/shopee-qrcode.png",
        class: "image-style",
        style: {"width":"150px"}
      })
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.lazada.sg/shop/gda-global-data-assistant",
      class: "qr-link",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("span", null, "Click to go to our Lazada store"),
      /*#__PURE__*/_createElementVNode("img", {
        src: "/images/redeem/lazada-qrcode.png",
        class: "image-style",
        style: {"width":"150px"}
      })
    ])
  ])
], -1))


import { defineComponent, reactive } from 'vue'
import store from '../store'
import { apiPostData, getI18n } from '../utils'
import router from '@/router'

const __default__ = defineComponent({
  name: 'RedeemGiftView'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// do not use same name with ref
const form = reactive({
  redeemCode: '',
  email: '',
  package: 'asia-9-200M',
  redeemType: 'esim',
  simNo: ''
})

const onSubmit = () => {
  console.log('submit!')
  const data = {
    redeemCode: form.redeemCode,
    email: form.email,
    package: form.package,
    redeemType: form.redeemType,
    simNo: form.simNo
  }
  // 这样提交的只有默认的表单数据，没有文件的数据
  apiPostData('/rdm/v1/redeem_code/redeem-gift', data)
    .then(data => {
      console.log('onSubmit data=', data)
      store.state.redeemResult = data
      // window.location.href = '/redeem-gift-result'
      router.push('/redeem-gift-result')
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_image, { src: './images/gda-log.png' }, null, 8, ["src"])
      ])
    ]),
    _createVNode(_component_el_form, {
      model: form,
      "label-width": "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(getI18n)('兑换码', 'Redeem Code')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.redeemCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.redeemCode) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(getI18n)('邮箱', 'email')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.email) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(getI18n)('套餐', 'Package')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "custom-select-height",
              modelValue: form.package,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.package) = $event)),
              name: "region",
              placeholder: "please select your package"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Aisa 9 200M",
                  value: "asia-9-200M"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: onSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getI18n)('兑换', 'redeem')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _createElementVNode("div", null, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("h2", null, _toDisplayString(_unref(getI18n)('查询流量 & FAQ', 'Check Data & FAQ')), 1)
          ])
        ]),
        _createVNode(_component_el_divider),
        _hoisted_6
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})